(() => {
  const sectionEvents = ['shopify:section:load', 'shopify:section:select', 'shopify:block:select'];

  const scopedId = (element) => {
    const id = element && element.id ? element.id : '';
    return id.split('-').slice(1).join('-');
  };

  const hasSwiper = () => typeof window.Swiper !== 'undefined';

  const initTilesSwiper = (root = document) => {
    if (!hasSwiper()) return;
    root.querySelectorAll('[id^="tilesSwiper-"]').forEach((slider) => {
      if (slider.swiper) return;
      const sectionId = scopedId(slider);
      const progress = document.getElementById(`progressBar-${sectionId}`);
      const updateProgress = (swiper) => {
        if (!progress || !swiper) return;
        const visible = Number(swiper.params.slidesPerView) || 1;
        const total = swiper.slides.length || 1;
        const maxIndex = Math.max(0, total - visible);
        const width = Math.min(100, (visible / total) * 100);
        const offset = maxIndex > 0 ? (swiper.activeIndex / maxIndex) * (100 - width) : 0;
        progress.style.width = `${width}%`;
        progress.style.transform = `translateX(${offset}%)`;
      };

      new window.Swiper(slider, {
        slidesPerView: 1.45,
        spaceBetween: 16,
        autoHeight: false,
        wrapperClass: `swiper-wrapper-${sectionId}`,
        slideClass: `swiper-slide-${sectionId}`,
        breakpoints: {
          900: { slidesPerView: 4.15, spaceBetween: 20 }
        },
        navigation: {
          nextEl: `.swiper-button-next-${sectionId}`,
          prevEl: `.swiper-button-prev-${sectionId}`
        },
        on: {
          init() { updateProgress(this); },
          slideChange() { updateProgress(this); },
          resize() { updateProgress(this); }
        }
      });
    });
  };

  const initRidersSwiper = (root = document) => {
    if (!hasSwiper()) return;
    root.querySelectorAll('[class^="riders-section-"] [id^="xbizSwiper-"]').forEach((slider) => {
      if (slider.swiper) return;
      new window.Swiper(slider, {
        autoHeight: true,
        slidesPerView: 1.18,
        spaceBetween: 14,
        breakpoints: {
          800: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    });
  };

  const initShowcaseSwiper = (root = document) => {
    if (!hasSwiper()) return;
    root.querySelectorAll('[class^="showcase-container-"] [id^="swiper-"]').forEach((slider) => {
      if (slider.swiper) return;
      const section = slider.closest('[class^="showcase-container-"]');
      const desktopSlides = Number(slider.dataset.slidesPerView || 3);
      const carousel = new window.Swiper(slider, {
        autoHeight: true,
        slidesPerView: 1.18,
        spaceBetween: 12,
        breakpoints: {
          800: { slidesPerView: desktopSlides, spaceBetween: 20 }
        },
        navigation: {
          nextEl: `#${slider.id} .swiper-button-next`,
          prevEl: `#${slider.id} .swiper-button-prev`
        }
      });

      if (!section) return;
      const categoryButtons = Array.from(section.querySelectorAll('[class^="category-btn-"]'));
      const activeClass = categoryButtons
        .flatMap((button) => Array.from(button.classList))
        .find((className) => className.startsWith('active-')) || 'is-active';

      categoryButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const selected = button.getAttribute('data-category');
          categoryButtons.forEach((item) => {
            item.classList.toggle(activeClass, item === button);
          });
          section.querySelectorAll('[class*="product-slide-"]').forEach((slide) => {
            slide.style.display = slide.getAttribute('data-category') === selected ? 'block' : 'none';
          });
          carousel.update();
          carousel.slideTo(0);
        });
      });
    });
  };

  const initTestimonials = (root = document) => {
    if (!hasSwiper()) return;
    root.querySelectorAll('[class^="testimonial-section-"] [id^="xbizSwiper-"]').forEach((slider) => {
      if (slider.swiper) return;
      const section = slider.closest('[class^="testimonial-section-"]');
      const logos = section ? Array.from(section.querySelectorAll('[class^="media-logo-"]')) : [];
      const setLogo = (index) => {
        logos.forEach((logo, logoIndex) => {
          logo.classList.toggle('logo-active', logos.length > 0 && logoIndex === index % logos.length);
        });
      };

      const carousel = new window.Swiper(slider, {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 18,
        pagination: {
          el: `#${slider.id} .swiper-pagination`,
          clickable: true
        },
        navigation: {
          nextEl: `#${slider.id} .swiper-button-next`,
          prevEl: `#${slider.id} .swiper-button-prev`
        },
        on: {
          init() { setLogo(0); },
          slideChange() {
            const slide = this.slides[this.activeIndex];
            const index = Number(slide && slide.getAttribute('data-testimonial-index'));
            setLogo(Number.isNaN(index) ? this.activeIndex : index);
          }
        }
      });

      logos.forEach((logo, index) => {
        logo.addEventListener('click', () => {
          const target = Array.from(slider.querySelectorAll('.swiper-slide')).findIndex((slide) => {
            const testimonialIndex = Number(slide.getAttribute('data-testimonial-index'));
            return !Number.isNaN(testimonialIndex) && testimonialIndex % logos.length === index;
          });
          if (target >= 0) carousel.slideTo(target);
        });
      });
    });
  };

  const initColorSwatches = (root = document) => {
    root.querySelectorAll('[class^="riders-section-"] [class^="color-swatch-"]').forEach((swatch) => {
      if (swatch.dataset.premiumBound === 'true') return;
      swatch.dataset.premiumBound = 'true';
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const slide = swatch.closest('.swiper-slide');
        const image = slide && slide.querySelector('[class^="product-image-"]');
        const imageUrl = swatch.getAttribute('data-image-url');
        if (!image || !imageUrl) return;

        image.style.opacity = '0.48';
        const nextImage = new Image();
        nextImage.onload = nextImage.onerror = () => {
          image.src = imageUrl;
          const srcset = swatch.getAttribute('data-image-srcset');
          if (srcset) image.srcset = srcset;
          image.alt = swatch.getAttribute('data-value') || image.alt;
          requestAnimationFrame(() => { image.style.opacity = '1'; });
        };
        nextImage.src = imageUrl;

        const variantInput = slide.querySelector('input[name="id"]');
        const variantId = swatch.getAttribute('data-variant-id');
        if (variantInput && variantId) variantInput.value = variantId;

        slide.querySelectorAll('[class^="color-swatch-"]').forEach((item) => item.classList.remove('active'));
        swatch.classList.add('active');
      });
    });
  };

  const initMotion = (root = document) => {
    if (!window.gsap || !window.ScrollTrigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.gsap.registerPlugin(window.ScrollTrigger);

    root.querySelectorAll('[data-premium-reveal]').forEach((element) => {
      if (element.dataset.motionInit === 'true') return;
      element.dataset.motionInit = 'true';
      window.gsap.fromTo(element, {
        autoAlpha: 0,
        y: 28
      }, {
        autoAlpha: 1,
        y: 0,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: element,
          start: 'top 86%',
          once: true
        }
      });
    });

    root.querySelectorAll('[data-premium-parallax]').forEach((element) => {
      if (element.dataset.parallaxInit === 'true') return;
      element.dataset.parallaxInit = 'true';
      window.gsap.to(element, {
        yPercent: 8,
        ease: 'none',
        scrollTrigger: {
          trigger: element.closest('[data-premium-section]') || element,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    });
  };

  const initHome = (root = document) => {
    initTilesSwiper(root);
    initRidersSwiper(root);
    initShowcaseSwiper(root);
    initTestimonials(root);
    initColorSwatches(root);
    initMotion(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHome());
  } else {
    initHome();
  }

  sectionEvents.forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      initHome(event.target || document);
      if (eventName === 'shopify:block:select') {
        const carousel = event.target.closest('[id^="carousel-"]');
        if (carousel && window.bootstrap) {
          window.bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false }).to(Number(event.target.dataset.index || 0));
        }
      }
    });
  });
})();
